import type { ReactNode } from 'react'
import { Box, Flex, Text } from '@radix-ui/themes'

interface FieldShellProps {
  label: string
  // Right-aligned in the label row, never beside the control: a button there
  // shrinks the control and breaks the column rules of the surrounding grid.
  action?: ReactNode
  hint?: ReactNode
  children: ReactNode
}

// The label row keeps a fixed height whether or not it carries an action, so a
// field with one starts its control at the same y as its row neighbours.
export const FieldShell = ({ label, action, hint, children }: FieldShellProps) => (
  <Box>
    <Flex align="center" justify="between" gap="2" mb="1" className="h-6">
      <Text as="label" size="1" color="gray" truncate>
        {label}
      </Text>
      {action}
    </Flex>
    {children}
    {hint ? <Box mt="1">{hint}</Box> : null}
  </Box>
)
